'use client';
/**
 * ⑭ 통합 — 탐색 자리(slot)에 R14b 지역 칩·전역 검색을 꽂기 위한 데이터 통로.
 * (main)/layout 이 서버에서 읽은 값(headerRegion = regions 표, popular = v_search_top_keywords_clean)을
 * ClientShell 이 한 번 내려 준다. 방문자와 무관한 값뿐이다(쿠키·세션 없음 — 서버 HTML 봇/일반 동일).
 */
import { createContext, useContext, type ReactNode } from 'react';
import type { HeaderRegionData } from '@/lib/v3/header-region-match';

export interface NavData {
  headerRegion: HeaderRegionData | null;
  popular: readonly string[];
  /** 킬 스위치 ui/nav_v2(서버 값). false 면 ⑭ 전역 지역 칩·검색 자리를 그리지 않는다(구 탐색 복귀). */
  navV2: boolean;
  /** search_unify1 — 「{지역} 인기 단지·검색어」 노출 플래그 ui.popular_region(서버 값 · 기본 off). */
  popularOn: boolean;
}

const NavDataContext = createContext<NavData>({ headerRegion: null, popular: [], navV2: true, popularOn: false });

export function NavDataProvider({ headerRegion, popular, navV2 = true, popularOn = false, children }: { headerRegion?: HeaderRegionData | null; popular?: readonly string[]; navV2?: boolean; popularOn?: boolean; children?: ReactNode }) {
  return <NavDataContext.Provider value={{ headerRegion: headerRegion ?? null, popular: popular ?? [], navV2, popularOn }}>{children}</NavDataContext.Provider>;
}

export function useNavData(): NavData {
  return useContext(NavDataContext);
}
